import { render, staticRenderFns } from "./CabinType.vue?vue&type=template&id=16b7d714&scoped=true&"
import script from "./CabinType.vue?vue&type=script&lang=js&"
export * from "./CabinType.vue?vue&type=script&lang=js&"
import style0 from "./CabinType.vue?vue&type=style&index=0&id=16b7d714&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b7d714",
  null
  
)

export default component.exports